import React from 'react';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  to: string;
  label?: string;
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
}

const BackButton: React.FC<BackButtonProps> = ({ 
  to, 
  label = 'Volver', 
  variant = 'text',
  size = 'medium'
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
  };

  return (
    <Button
      variant={variant}
      size={size}
      startIcon={<ArrowBack />}
      onClick={handleClick}
      sx={{
        textTransform: 'none',
        borderColor: '#E0E0E0',
        color: '#666666',
        bgcolor: '#E6E6E6',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '100%',
        letterSpacing: '0%',
        width: '168px',
        height: '42px',
        '&:hover': {
          borderColor: '#CCCCCC',
          backgroundColor: '#F5F5F5'
        }
      }}
    >
      {label}
    </Button>
  );
};

export default BackButton;
